import type { ProjectCostEvent } from "@zplanem/responses"
import type React from "react"
import { getTranslations } from "../../../i18n"
import { useLocale } from "../../../locale-context"
import { JournalRowShell } from "../journal-row-shell"
import { interpolate, resolveActor } from "../resolve-actor"

const CostIcon: React.FC = () => (
	<svg
		viewBox="0 0 16 16"
		fill="none"
		stroke="currentColor"
		strokeWidth="1.5"
		strokeLinecap="round"
		strokeLinejoin="round"
		className="w-5 h-5"
		aria-hidden="true"
	>
		<circle cx="8" cy="8" r="5.5" />
		<path d="M8 5v1.5M8 9.5V11M6.5 6.5h1.75a1 1 0 0 1 0 2H7.5a1 1 0 0 0 0 2H9.5" />
	</svg>
)

const costCopyKey = {
	"project.cost_proposed": "projectCostProposed",
	"project.cost_accepted": "projectCostAccepted",
	"project.cost_rejected": "projectCostRejected",
	"project.paid": "projectPaid",
} as const satisfies Record<
	ProjectCostEvent["type"],
	keyof ReturnType<typeof getTranslations>["journal"]["events"]
>

export function ProjectCostRow({ event }: { event: ProjectCostEvent }) {
	const { locale } = useLocale()
	const t = getTranslations(locale)
	const actor = resolveActor(event.actor, t)
	const copy = t.journal.events[costCopyKey[event.type]]
	const { amount, currency } = event.payload
	return (
		<JournalRowShell
			icon={<CostIcon />}
			headline={interpolate(copy.label, { actor, amount, currency })}
			actor={actor}
			iso={event.createdAt}
			eventType={event.type}
			aria={interpolate(copy.aria, { actor, amount, currency })}
		/>
	)
}
